import { NOT_ACCESSIBLE } from "common/constants";

export const getDisplayValue = (
  value: number,
  customValue?: string
): string => {
  if (customValue) {
    return customValue;
  }

  if (!Number.isInteger(value)) {
    return NOT_ACCESSIBLE;
  }

  return `${value}`;
};
